import { Injectable } from "@angular/core";
import { SharedExportResourceToProductionJobSharedMapper } from "@models/mappers/shared-export-resource-to-production-job-shared-detail.mapper";
import { ProductionJobShared } from "@models/production-job-shared.model";
import { SharedExportResponse } from "@models/resource/shared-export.resource";
import { SdkBase } from "@utilities/sdk-base/sdk.base";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SharedExportSdk extends SdkBase {
  public getProductionJobShared(productionId: string): Observable<ProductionJobShared> {
    return this.makeHttpRequest<SharedExportResponse>('get', `api2/SharedProductionJobs/${productionId}`).pipe(
      map((response) => {
        const mapper = new SharedExportResourceToProductionJobSharedMapper();
        return mapper.map(response);
      })
    );
  }

  public createProductionShared(sharedJob: ProductionJobShared): Observable<ProductionJobShared> {
    return this.makeHttpRequest<SharedExportResponse>('post', `api2/SharedProductionJobs/`, sharedJob).pipe(
      map((response) => {
        const mapper = new SharedExportResourceToProductionJobSharedMapper();
        return mapper.map(response);
      })
    );
  }

  public deleteProductionShared(sharedId: string): Observable<boolean> {
    return this.makeHttpRequest<boolean>('delete', `api2/SharedProductionJobs/${sharedId}`).pipe(
      catchError(() => {
        return of(null);
      }));
  }
  
}
